"use client";

import { Button } from "@/shared-web.ui/ui.button";

interface StartNowButtonProps {
  label: string;
  startNowDivId: string;
}
export const StartNowButton = (props: StartNowButtonProps) => {
  const { startNowDivId, label } = props;

  const handleScroll = () => {
    const target = document.getElementById(startNowDivId);
    if (target) {
      const navbarHeight = 72;
      const yOffset = -navbarHeight;
      const y = target.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <Button
      onClick={handleScroll}
      size="3"
      variant="solid"
    >
      {label}
    </Button>
  );
};
